// Estado compartilhado para toggle dos painéis de debug
let debugVisible = false;
const debugListeners = new Set();

export function setDebugVisibility(value) {
  debugVisible = value;
  debugListeners.forEach(listener => listener(value));
}

export function getDebugVisibility() {
  return debugVisible;
}

export function subscribeDebugVisibility(listener) {
  debugListeners.add(listener);
  return () => {
    debugListeners.delete(listener);
  };
}

